module.exports = __webpack_public_path__ + "img/logo_original.a7f963e1.png";